import { Layout, Menu } from 'antd'
import { AppHeader } from './AppHeader'
import { Link } from 'react-router-dom'

import './AppLayout.css'

const { Header, Content, Footer } = Layout

export const AppLayout = ({ children }) => {
  const year = new Date().getFullYear()

  return (
    <Layout className='layout-wrapper'>
      <AppHeader />
      <Content className='layout-content__wrapper'>
        <div className='layout-content__body'>{children}</div>
      </Content>
      <Footer
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        className='layout-footer__wrapper'
      >
        <p style={{ paddingRight: 20, width: 'fit-content' }}>
          PICnFIND @{year}
        </p>
        <Link to={'/administrator/privacy-policy'}>Privacy Policy</Link>
      </Footer>
    </Layout>
  )
}
